/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TestRouteImport } from './routes/test'
import { Route as SitemapRouteImport } from './routes/sitemap'
import { Route as ScheduleAMeetingRouteImport } from './routes/schedule-a-meeting'
import { Route as RatesRouteImport } from './routes/rates'
import { Route as ErrorRouteImport } from './routes/error'
import { Route as ConfirmationRouteImport } from './routes/confirmation'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as BlocksRouteImport } from './routes/blocks'
import { Route as SplatRouteImport } from './routes/$'
import { Route as RoomsRouteRouteImport } from './routes/rooms/route'
import { Route as HotelsRouteRouteImport } from './routes/hotels/route'
import { Route as RoomsIndexRouteImport } from './routes/rooms/index'
import { Route as HotelsIndexRouteImport } from './routes/hotels/index'
import { Route as RoomsRoomIdRouteImport } from './routes/rooms/$roomId'
import { Route as HotelsHotelIdRouteImport } from './routes/hotels/$hotelId'

const TestRoute = TestRouteImport.update({
  id: '/test',
  path: '/test',
  getParentRoute: () => rootRouteImport,
} as any)
const SitemapRoute = SitemapRouteImport.update({
  id: '/sitemap',
  path: '/sitemap',
  getParentRoute: () => rootRouteImport,
} as any)
const ScheduleAMeetingRoute = ScheduleAMeetingRouteImport.update({
  id: '/schedule-a-meeting',
  path: '/schedule-a-meeting',
  getParentRoute: () => rootRouteImport,
} as any)
const RatesRoute = RatesRouteImport.update({
  id: '/rates',
  path: '/rates',
  getParentRoute: () => rootRouteImport,
} as any)
const ErrorRoute = ErrorRouteImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfirmationRoute = ConfirmationRouteImport.update({
  id: '/confirmation',
  path: '/confirmation',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutRoute = CheckoutRouteImport.update({
  id: '/checkout',
  path: '/checkout',
  getParentRoute: () => rootRouteImport,
} as any)
const BlocksRoute = BlocksRouteImport.update({
  id: '/blocks',
  path: '/blocks',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const RoomsRouteRoute = RoomsRouteRouteImport.update({
  id: '/rooms',
  path: '/rooms',
  getParentRoute: () => rootRouteImport,
} as any)
const HotelsRouteRoute = HotelsRouteRouteImport.update({
  id: '/hotels',
  path: '/hotels',
  getParentRoute: () => rootRouteImport,
} as any)
const RoomsIndexRoute = RoomsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RoomsRouteRoute,
} as any)
const HotelsIndexRoute = HotelsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => HotelsRouteRoute,
} as any)
const RoomsRoomIdRoute = RoomsRoomIdRouteImport.update({
  id: '/$roomId',
  path: '/$roomId',
  getParentRoute: () => RoomsRouteRoute,
} as any)
const HotelsHotelIdRoute = HotelsHotelIdRouteImport.update({
  id: '/$hotelId',
  path: '/$hotelId',
  getParentRoute: () => HotelsRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/hotels': typeof HotelsRouteRouteWithChildren
  '/rooms': typeof RoomsRouteRouteWithChildren
  '/$': typeof SplatRoute
  '/blocks': typeof BlocksRoute
  '/checkout': typeof CheckoutRoute
  '/confirmation': typeof ConfirmationRoute
  '/error': typeof ErrorRoute
  '/rates': typeof RatesRoute
  '/schedule-a-meeting': typeof ScheduleAMeetingRoute
  '/sitemap': typeof SitemapRoute
  '/test': typeof TestRoute
  '/hotels/$hotelId': typeof HotelsHotelIdRoute
  '/rooms/$roomId': typeof RoomsRoomIdRoute
  '/hotels/': typeof HotelsIndexRoute
  '/rooms/': typeof RoomsIndexRoute
}
export interface FileRoutesByTo {
  '/$': typeof SplatRoute
  '/blocks': typeof BlocksRoute
  '/checkout': typeof CheckoutRoute
  '/confirmation': typeof ConfirmationRoute
  '/error': typeof ErrorRoute
  '/rates': typeof RatesRoute
  '/schedule-a-meeting': typeof ScheduleAMeetingRoute
  '/sitemap': typeof SitemapRoute
  '/test': typeof TestRoute
  '/hotels/$hotelId': typeof HotelsHotelIdRoute
  '/rooms/$roomId': typeof RoomsRoomIdRoute
  '/hotels': typeof HotelsIndexRoute
  '/rooms': typeof RoomsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/hotels': typeof HotelsRouteRouteWithChildren
  '/rooms': typeof RoomsRouteRouteWithChildren
  '/$': typeof SplatRoute
  '/blocks': typeof BlocksRoute
  '/checkout': typeof CheckoutRoute
  '/confirmation': typeof ConfirmationRoute
  '/error': typeof ErrorRoute
  '/rates': typeof RatesRoute
  '/schedule-a-meeting': typeof ScheduleAMeetingRoute
  '/sitemap': typeof SitemapRoute
  '/test': typeof TestRoute
  '/hotels/$hotelId': typeof HotelsHotelIdRoute
  '/rooms/$roomId': typeof RoomsRoomIdRoute
  '/hotels/': typeof HotelsIndexRoute
  '/rooms/': typeof RoomsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/hotels'
    | '/rooms'
    | '/$'
    | '/blocks'
    | '/checkout'
    | '/confirmation'
    | '/error'
    | '/rates'
    | '/schedule-a-meeting'
    | '/sitemap'
    | '/test'
    | '/hotels/$hotelId'
    | '/rooms/$roomId'
    | '/hotels/'
    | '/rooms/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/$'
    | '/blocks'
    | '/checkout'
    | '/confirmation'
    | '/error'
    | '/rates'
    | '/schedule-a-meeting'
    | '/sitemap'
    | '/test'
    | '/hotels/$hotelId'
    | '/rooms/$roomId'
    | '/hotels'
    | '/rooms'
  id:
    | '__root__'
    | '/hotels'
    | '/rooms'
    | '/$'
    | '/blocks'
    | '/checkout'
    | '/confirmation'
    | '/error'
    | '/rates'
    | '/schedule-a-meeting'
    | '/sitemap'
    | '/test'
    | '/hotels/$hotelId'
    | '/rooms/$roomId'
    | '/hotels/'
    | '/rooms/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  HotelsRouteRoute: typeof HotelsRouteRouteWithChildren
  RoomsRouteRoute: typeof RoomsRouteRouteWithChildren
  SplatRoute: typeof SplatRoute
  BlocksRoute: typeof BlocksRoute
  CheckoutRoute: typeof CheckoutRoute
  ConfirmationRoute: typeof ConfirmationRoute
  ErrorRoute: typeof ErrorRoute
  RatesRoute: typeof RatesRoute
  ScheduleAMeetingRoute: typeof ScheduleAMeetingRoute
  SitemapRoute: typeof SitemapRoute
  TestRoute: typeof TestRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/test': {
      id: '/test'
      path: '/test'
      fullPath: '/test'
      preLoaderRoute: typeof TestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sitemap': {
      id: '/sitemap'
      path: '/sitemap'
      fullPath: '/sitemap'
      preLoaderRoute: typeof SitemapRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/schedule-a-meeting': {
      id: '/schedule-a-meeting'
      path: '/schedule-a-meeting'
      fullPath: '/schedule-a-meeting'
      preLoaderRoute: typeof ScheduleAMeetingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rates': {
      id: '/rates'
      path: '/rates'
      fullPath: '/rates'
      preLoaderRoute: typeof RatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/error': {
      id: '/error'
      path: '/error'
      fullPath: '/error'
      preLoaderRoute: typeof ErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/confirmation': {
      id: '/confirmation'
      path: '/confirmation'
      fullPath: '/confirmation'
      preLoaderRoute: typeof ConfirmationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout': {
      id: '/checkout'
      path: '/checkout'
      fullPath: '/checkout'
      preLoaderRoute: typeof CheckoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blocks': {
      id: '/blocks'
      path: '/blocks'
      fullPath: '/blocks'
      preLoaderRoute: typeof BlocksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rooms': {
      id: '/rooms'
      path: '/rooms'
      fullPath: '/rooms'
      preLoaderRoute: typeof RoomsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/hotels': {
      id: '/hotels'
      path: '/hotels'
      fullPath: '/hotels'
      preLoaderRoute: typeof HotelsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rooms/': {
      id: '/rooms/'
      path: '/'
      fullPath: '/rooms/'
      preLoaderRoute: typeof RoomsIndexRouteImport
      parentRoute: typeof RoomsRouteRoute
    }
    '/hotels/': {
      id: '/hotels/'
      path: '/'
      fullPath: '/hotels/'
      preLoaderRoute: typeof HotelsIndexRouteImport
      parentRoute: typeof HotelsRouteRoute
    }
    '/rooms/$roomId': {
      id: '/rooms/$roomId'
      path: '/$roomId'
      fullPath: '/rooms/$roomId'
      preLoaderRoute: typeof RoomsRoomIdRouteImport
      parentRoute: typeof RoomsRouteRoute
    }
    '/hotels/$hotelId': {
      id: '/hotels/$hotelId'
      path: '/$hotelId'
      fullPath: '/hotels/$hotelId'
      preLoaderRoute: typeof HotelsHotelIdRouteImport
      parentRoute: typeof HotelsRouteRoute
    }
  }
}

interface HotelsRouteRouteChildren {
  HotelsHotelIdRoute: typeof HotelsHotelIdRoute
  HotelsIndexRoute: typeof HotelsIndexRoute
}

const HotelsRouteRouteChildren: HotelsRouteRouteChildren = {
  HotelsHotelIdRoute: HotelsHotelIdRoute,
  HotelsIndexRoute: HotelsIndexRoute,
}

const HotelsRouteRouteWithChildren = HotelsRouteRoute._addFileChildren(
  HotelsRouteRouteChildren,
)

interface RoomsRouteRouteChildren {
  RoomsRoomIdRoute: typeof RoomsRoomIdRoute
  RoomsIndexRoute: typeof RoomsIndexRoute
}

const RoomsRouteRouteChildren: RoomsRouteRouteChildren = {
  RoomsRoomIdRoute: RoomsRoomIdRoute,
  RoomsIndexRoute: RoomsIndexRoute,
}

const RoomsRouteRouteWithChildren = RoomsRouteRoute._addFileChildren(
  RoomsRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  HotelsRouteRoute: HotelsRouteRouteWithChildren,
  RoomsRouteRoute: RoomsRouteRouteWithChildren,
  SplatRoute: SplatRoute,
  BlocksRoute: BlocksRoute,
  CheckoutRoute: CheckoutRoute,
  ConfirmationRoute: ConfirmationRoute,
  ErrorRoute: ErrorRoute,
  RatesRoute: RatesRoute,
  ScheduleAMeetingRoute: ScheduleAMeetingRoute,
  SitemapRoute: SitemapRoute,
  TestRoute: TestRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
